module.exports = __webpack_public_path__ + "assets/img/banner4.8e7db3f3.png";